export default __webpack_public_path__ + "img/8685858edabe169535bd3bb7f18e9ca5.png";